import dangerousStyleValue from './dangerousStyleValue';
import warnValidStyle from './warnValidStyle';
export function setValueForStyles(node, styles) {
    var style = node.style;
    var keys = Object.keys(styles);
    for (var i = 0; i < keys.length; i += 1) {
        var styleName = keys[i];
        var isCustomProperty = styleName.indexOf('--') === 0;
        if (process.env.NODE_ENV !== 'production') {
            if (!isCustomProperty) {
                warnValidStyle(styleName, styles[styleName]);
            }
        }
        var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
        if (styleName === 'float') {
            styleName = 'cssFloat';
        }
        if (isCustomProperty) {
            style.setProperty(styleName, styleValue);
        }
        else {
            style[styleName] = styleValue;
        }
    }
}
